module.exports = __webpack_public_path__ + "img/fi-rr-barber-shop.fcd6620e.svg";